<!-- Copyright SAGT 2021 -->
<app-dashboard-controls #dashboardControlsComponent></app-dashboard-controls>

<app-dashboard #dashboardComponent class="dashboard-container"></app-dashboard>

<footer [style.display]="displayFooter" class="version-container">
  <span>{{ version$ | async }}</span>
</footer>
